// extracted by mini-css-extract-plugin
export var active = "_6m-c";
export var activeIndicator = "_6m-7";
export var animate = "_6m-b";
export var contentWidthTabs = "_6m-5";
export var disabled = "_6m-d";
export var flat = "_6m-1";
export var fullWidth = "_6m-3";
export var lg = "_6m-a";
export var md = "_6m-9";
export var redoButtonTabGroup = "_6m-0";
export var sm = "_6m-8";
export var tabButton = "_6m-4";
export var tabButtonsContainer = "_6m-2";
export var xs = "_6m-6";